import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Container, Form, Button, Spinner, Alert, InputGroup, Modal } from 'react-bootstrap';
import '../../styles/LpTemplates.css'; // Importa os estilos dos templates
import '../../styles/LeadCapturePage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Importa os componentes de template
import TemplateDefault from '../../components/public/lp_templates/TemplateDefault';
import TemplateVideoHero from '../../components/public/lp_templates/TemplateVideoHero'; // Crie este arquivo
import TemplateOfertaDireta from '../../components/public/lp_templates/TemplateOfertaDireta'; // Crie este arquivo

import axios from 'axios';

// Simula uma chamada de API para buscar os dados do serviço e da entidade
const fetchServiceData = async (entidadeSlug, servicoSlug, axiosInstance) => {
    const response = await axiosInstance.get(`/api/public/landing-page/${entidadeSlug}/${servicoSlug}`);
    return response.data;
};

const LeadCapturePage = () => {
    const { entidadeSlug, servicoSlug } = useParams();
    const [searchParams] = useSearchParams();
    const representante = searchParams.get('rep');
    const [entidade, setEntidade] = useState(null);
    const [servico, setServico] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showOfferModal, setShowOfferModal] = useState(false);
    const [submitStatus, setSubmitStatus] = useState({ submitted: false, message: '', variant: '' });

    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        telefone: '',
    });

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            try {
                // Cria uma instância do axios sem interceptadores para a chamada pública
                const publicAxios = axios.create();
                const data = await fetchServiceData(entidadeSlug, servicoSlug, publicAxios);
                setEntidade(data.entidade);
                setServico(data.servico);
            } catch (err) {
                setError('Não foi possível carregar as informações do serviço.');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };
        loadData();
    }, [entidadeSlug, servicoSlug]); // Dependências corretas

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const publicAxios = axios.create();
            const payload = {
                ...formData,
                entidade_id: entidade.id,
                servico_id: servico.id, // Opcional, se quiser ligar o lead a um serviço específico
                status: 'novo', // Status inicial padrão
                prioridade: 'media', // Prioridade inicial padrão
                nota_inicial: `Usuário interessado em '${servico.nome || servicoSlug.replace(/-/g, ' ')}', Não houve contato inicial ainda.`
            };

            const captureResponse = await publicAxios.post(`/api/public/landing-page/${entidadeSlug}/${servicoSlug}/leads`, { nome: payload.nome, telefone: payload.telefone, email: payload.email, representante });

            const numeroDestino = captureResponse.data?.whatsapp_numero || entidade?.whatsapp_funil;
            // --- NOVA LÓGICA DE REDIRECIONAMENTO ---
            // Prioridade 1: URL de redirecionamento customizada no serviço.
            if (!representante && servico && servico.redirect_url) {
                setSubmitStatus({ submitted: true, message: 'Obrigado! Você será redirecionado em instantes...', variant: 'success' });
                window.location.href = servico.redirect_url;
            // Prioridade 2: WhatsApp configurado na entidade.
            } else if (numeroDestino) {
                setSubmitStatus({ submitted: true, message: 'Obrigado! Você será redirecionado para o WhatsApp.', variant: 'success' });
                const numeroWhatsapp = numeroDestino.replace(/\D/g, ''); // Remove caracteres não numéricos
                const textoWhatsapp = encodeURIComponent(`Olá, meu nome é ${formData.nome} e tenho interesse em ${servico.nome || servico.titulo_pagina}.`);
                const urlWhatsapp = `https://wa.me/${numeroWhatsapp}?text=${textoWhatsapp}`;
                window.location.href = urlWhatsapp;
            } else {
                setSubmitStatus({ submitted: true, message: 'Obrigado pelo seu interesse! Entraremos em contato em breve.', variant: 'success' });
            }

            // Limpa o formulário e mostra a mensagem de sucesso
            setFormData({ nome: '', email: '', telefone: '' });

        } catch (submitError) {
            console.error("Erro ao enviar lead:", submitError);
            setSubmitStatus({ submitted: true, message: 'Ocorreu um erro ao registrar seu interesse. Por favor, tente novamente.', variant: 'danger' });
        } finally {
            setIsLoading(false);
            // Se o modal de oferta estiver aberto, vamos fechá-lo após o envio
            if (showOfferModal) {
                // A mensagem de sucesso/erro já aparece dentro do modal
                // Podemos adicionar um delay antes de fechar, se desejado
            }
        }
    };

    // Função para renderizar o template correto
    const renderTemplate = () => {
        const templateProps = {
            entidade,
            servico,
            formData,
            submitStatus,
            isLoading,
            handleChange,
            handleSubmit,
            setShowOfferModal
        };

        switch (servico.template_slug) {
            case 'video_hero':
                return <TemplateVideoHero {...templateProps} />;
            case 'oferta_direta':
                return <TemplateOfertaDireta {...templateProps} />;
            default:
                return <TemplateDefault {...templateProps} />;
        }
    };

    if (isLoading && !servico) {
        return (
            <Container className="d-flex justify-content-center align-items-center vh-100">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </Spinner>
            </Container>
        );
    }

    if (error) {
        return <Container className="text-center mt-5"><Alert variant="danger">{error}</Alert></Container>;
    }

    return (
        <div className="lead-capture-page-wrapper">
            {/* <header className="lp-header text-center py-3">
                <Image src={entidade.logo_path} alt={`Logo de ${entidade.nome}`} fluid style={{ maxHeight: '60px' }} />
            </header> */}

            {renderTemplate()}

            <footer className="text-center py-4 bg-dark text-white" style={{ position: 'relative', zIndex: 2 }}>
                <p className="mb-0">&copy; {new Date().getFullYear()} {entidade.nome}. Todos os direitos reservados.</p>
            </footer>

            {/* Modal de Oferta */}
            <Modal show={showOfferModal} onHide={() => setShowOfferModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{servico.titulo_oferta}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {submitStatus.submitted ? (
                        <Alert variant={submitStatus.variant} className="text-center">
                            <Alert.Heading>{submitStatus.variant === 'success' ? 'Obrigado!' : 'Ops!'}</Alert.Heading>
                            <p className="mb-0">{submitStatus.message}</p>
                        </Alert>
                    ) : (
                        <Form onSubmit={handleSubmit}>
                            <p>Não perca esta condição especial! Preencha seus dados abaixo que entraremos em contato.</p>
                            <InputGroup className="mb-3">
                                <InputGroup.Text><FontAwesomeIcon icon="user" /></InputGroup.Text>
                                <Form.Control type="text" name="nome" placeholder="Nome Completo" value={formData.nome} onChange={handleChange} required />
                            </InputGroup>
                            <InputGroup className="mb-3">
                                <InputGroup.Text><FontAwesomeIcon icon="envelope" /></InputGroup.Text>
                                <Form.Control type="email" name="email" placeholder="Seu melhor e-mail" value={formData.email} onChange={handleChange} required />
                            </InputGroup>
                            <InputGroup className="mb-3">
                                <InputGroup.Text><FontAwesomeIcon icon="phone" /></InputGroup.Text>
                                <Form.Control type="tel" name="telefone" placeholder="Telefone / WhatsApp" value={formData.telefone} onChange={handleChange} required />
                            </InputGroup>
                            <div className="d-grid"><Button variant="primary" type="submit" size="lg" disabled={isLoading}>{isLoading ? <Spinner as="span" size="sm" /> : "Solicitar avaliação Gratuita!"}</Button></div>
                        </Form>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default LeadCapturePage;
